/**
 * Product items slats
 *
 * @param {}
 * @return {void}
 */

export const addProductItemSlats = (item = '[data="js-slats"]') => {
  const $item = $(item);

  // get section-slats data
  const sectionSlatsData = $('.js-slats-data').text();

  if (sectionSlatsData.length == 0) {
    return;
  }

  if($item.hasClass('slat-initialized')){
    return;
  }

  const sizesArray = sectionSlatsData.split('##');



  $item.each(function() {
    const $this = $(this);
    const dataSlats = $this.data('slat-sizes');

    if (dataSlats) {
      let html = '';

      const dataSlatsArray = dataSlats.split('##');
      const productId = $this.data('product-id');
      const urls = $this.data('slat-url');
      let urls_arr = [];

      if(urls){
        urls_arr = urls.split('&&')
      }

      const $slatsContainer = $this.find('.js-product-item-slats');
      const hiddenClass = 'hidden';

      for (var i = 0; i < dataSlatsArray.length; i++) {
        let value = dataSlatsArray[i];
        let radioHTML = `
                        <li>
                          <div class="radio radio--slatsize">
                            <a href="/products/${urls_arr[i]}"></a>

                            <input
                              type="radio"
                              name="radio-slat-sizes"
                              id="radio-${productId}-${value}"
                              value="${value}"
                              data-slatsize="${value}"
                            />

                            <label for="radio-${productId}-${value}" data-slatsize="${value}">
                              <span class="radio__image" role="img" aria-label="Slat size image"></span>
                              <span class="radio__text">${value}</span>
                            </label>
                          </div><!-- /.radio -->
                        </li>
                        `

        for (var j = 0; j < sizesArray.length; j++) {
          let sizeValue = sizesArray[j];

          if (sizeValue == value) {
            html += radioHTML;
          }
        }
      }

      $slatsContainer.removeClass(hiddenClass).html(html);
      $item.addClass('slat-initialized')
    }
  });
};

window.ADD_PRODUCT_ITEM_SLATS = addProductItemSlats;

addProductItemSlats();

$(window).on('shopify:section:load', function(event) {
  addProductItemSlats();
});
